// Dependencies
import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';

// Styles
import './EventTickets.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function TicketsOverview(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		categoryPricelevelContainer: {
			lineHeight: context.themeManager
				.value('tickets-overview', 'lineHeight', 'line-height-300'),
		},
		categoryContainer: {
			display: 'flex',
			lineHeight: 'inherit',
			margin: '0 0 .1em',
		},
		priceLevelName: {
			fontSize: context.themeManager.value('tickets-overview', 'priceLevelFontSize', 'font-size-90'),
		},
		seatInfo: {
			fontSize: context.themeManager.value('tickets-overview', 'seatInfoFontSize', 'font-size-90'),
			fontWeight: 400,
		},
		icon: {
			color: context.themeManager.value('ticket-item-icon', 'color', 'fg-color-icon-highlight'),
		}
	};

	const sortedTickets = Object.assign([], props.tickets).sort((a, b) => (a.categoryType > b.categoryType ? 1 : -1));

	return (
		<div>
			{sortedTickets.map((ticketGroup, index) => (
				<div key={index.toString()}>
					<div className="event-tickets__container">
						<FontAwesomeIcon
							icon={ticketGroup.numberOfSeats > 1 ? 'tags' : 'tag'}
							style={style.icon}
							className="ticket-item__icon"
						/>
						<div style={style.categoryPricelevelContainer} className="category-price-container">
							<div style={style.categoryContainer} className="category-container">
								<div className="category__amount">
									{ticketGroup.numberOfSeats}
								</div>
								<div>x</div>
								<div className="category__name">
									{ticketGroup.category}
								</div>
							</div>
							<div className="pricelevel">
								<div style={style.priceLevelName} className="price-level__name">
									({ticketGroup.priceLevel},
								</div>
								<div style={style.seatInfo}>
									{ ticketGroup.block &&
									<span className="seat-info__element">Block {ticketGroup.block}</span>
									}
									{ ticketGroup.rowNumber &&
									<span className="seat-info__element">Reihe {ticketGroup.rowNumber}</span>
									}
									{ ticketGroup.seatNumber &&
									<span className="seat-info__element">Sitz {ticketGroup.seatNumber}</span>
									}
									{ ((ticketGroup.isVisualBulkTicket || (!ticketGroup.isVisualBulkTicket && !ticketGroup.isVisualTicket))) &&
									<span className="seat-info__element">Freie Platzwahl</span>
									}
									)</div>
							</div>
						</div>
						<div className="price__container">
							{ (ticketGroup.numberOfSeats > 1) &&
							<span className="category__total--info">(je {parseFloat(ticketGroup.pricePerSeat.money.value).toFixed(2)} €)</span>
							}
							<span className="category__total price">
								{parseFloat(ticketGroup.subTotal.money.value).toFixed(2)} €
							</span>
						</div>
					</div>
				</div>
			))}
		</div>
	);
}

// ------------------------------
// Store Connection
// ------------------------------

export default radium(TicketsOverview);
